<template>
  <div>
    <div class="top">
      <div class="main container F-flex">
        <div>康买 ：牙科一站式服务的行业先锋！</div>
        <div class="flex ali-cen set">
          <p @click="log_out" v-if="flag">退出</p>
          <div class="set-true">
            <span v-if="flag1" @click="jump('login', { type: 1 })">登录</span>
            <span v-if="flag1" style="margin: 0 10px">|</span>
            <span v-if="flag1" @click="jump('login', { type: 2 })">注册</span>
            <span v-if="flag" @click="jump('mine')">会员中心</span>
          </div>
          <div @click="companyIntroduction">公司介绍</div>
          <div @click="helpCenter">帮助中心</div>
          <div @click="recruitment">招聘信息</div>
          <div @click="infomation">最新资讯</div>
        </div>
      </div>
    </div>
    <template v-if="type">
      <div class="search container F-flex">
        <img src="../images/logo.png" alt="" class="logo" />
        <div class="search-con">
          <div class="iqehuan">
            <p
              @click="qiehuan(index)"
              :class="activeClass == index ? 'current_way' : 's'"
              v-for="(item, index) in qiehuanObj"
              :key="index"
              style="margin-right: 10px"
            >
              {{ item.name }}
            </p>
          </div>
          <div class="search-input F-flex">
            <input
              type="text"
              v-model="search"
              @keyup.enter="
                jumps('type', {
                  search: search,
                  type: pices,
                  activeClass: activeClass,
                })
              "
              :placeholder="value"
            />

            <div
              class="search-input-btn"
              @click="
                jumps('type', {
                  search: search,
                  type: pices,
                  activeClass: activeClass,
                })
              "
            >
              搜索
            </div>
          </div>

          <div class="flex search-text">
            <div
              v-for="(item, index) in goodSearchsLists"
              @click="
                jumps('type', {
                  search: item.keywords,
                  type: pices,
                  activeClass: activeClass,
                })
              "
              :key="index"
            >
              {{ item.keywords }}
            </div>
          </div>
        </div>
        <div class="car" @click="jump('cart')">
          <i
            class="iconfont ficon-shopingcar-o"
            style="font-size: 30px; color: #0097fe"
          ></i>
          购物车
          <div class="car-num">{{ cartNum }}</div>
        </div>
      </div>
      <div class="nav">
        <div class="container flex ali-cen">
          <div class="all-box">
            <div class="all flex ali-cen jus-cen" @click="clickSelect">
              全部商品 <i class="iconfont ficon-down"></i>
            </div>
            <div class="nav-select" v-if="selectShow">
              <div
                class="nav-item F-flex"
                @click="jump('type')"
                v-for="(i, index) in lists"
                :key="index"
              >
                <div>
                  <i class="iconfont ficon-star"></i>
                  <span>{{ i.name }}</span>
                </div>
                <i class="ficon-right iconfont"></i>
              </div>
            </div>
          </div>

          <div class="nav-tabs flex">
            <div :class="{ 'nav-true': id == 'index' }" @click="jump('index')">
              首页
            </div>
            <div :class="{ 'nav-true': id == 'new' }" @click="jump('new')">
              新品发布
            </div>
            <div
              :class="{ 'nav-true': id == 'special' }"
              @click="jump('special')"
            >
              特价专区
            </div>
            <div
              :class="{ 'nav-true': id == 'seckill' }"
              @click="jump('seckill')"
            >
              全网低价
            </div>
            <div :class="{ 'nav-true': id == 'mine' }" @click="jump('mine')">
              会员中心
            </div>
            <div :class="{ 'nav-true': id == 'brand' }" @click="jump('brand')">
              品牌检索
            </div>
            <div
              :class="{ 'nav-true': id == 'mini' }"
              @click="centerDialogVisible = true"
            >
              官方小程序
            </div>
          </div>
        </div>
        <el-dialog
          title="官方小程序"
          :visible.sync="centerDialogVisible"
          width="30%"
          center
        >
          <div class="erImg">
            <img src="../images/erweima.jpg" alt="" />
          </div>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="centerDialogVisible = false"
              >确 定</el-button
            > -->
          </span>
        </el-dialog>
      </div>
    </template>
    <template v-else>
      <div class="search container F-flex">
        <img src="../images/logo.png" alt="" class="logo" />
        <div class="step">
          <el-steps :active="active" align-center process-status="wait">
            <el-step title="提交订单"></el-step>
            <el-step title="确认付款"></el-step>
            <el-step title="商品发货"></el-step>
            <el-step title="确认收货"></el-step>
          </el-steps>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { shoproCategory, lists, goodSearch } from "@/api/index.js";
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    type: {
      type: Boolean,
      default: true,
    },
    id: {
      //导航选中状态
      type: String,
      default: "index",
    },
  },
  watch: {
    id: {
      handler(newValue) {
        if (newValue == "mine") {
        }
        console.log(newValue, "new");
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      selectShow: false,
      lists: [],
      search: "",
      active: 1,
      flag: true,
      flag1: false,
      centerDialogVisible: false,
      userId: "",
      goodSearchsLists: [],
      value: "",
      qiehuanObj: [
        {
          name: "商品",
        },
        {
          name: "型号",
        },
      ],
      activeClass: 0,
      pices: "0",
    };
  },
  computed: {
    ...mapState({
      cartNum: (state) => state.cartNum,
    }),
    ...mapGetters(["totalCount"]),
  },
  created() {
    this.list();
    this.userInfoTop();
    this.goodSearchs();
    this.value = window.sessionStorage.getItem("search");
      window.localStorage.setItem("activeClass", 0);
    if (!this.$route.query.activeClass) {
      this.activeClass = this.$route.query.activeClass;
    }
    this.activeClass = window.localStorage.getItem("activeClass");

    return;
  },
  methods: {
    clickSelect() {
      this.selectShow = !this.selectShow;
    },
    list() {
      shoproCategory().then((res) => {
        this.lists = res.data.children;
      });
    },
    jump(url, data = {}) {
      if (url == "mine" || url == "cart") {
        if (!localStorage.getItem("userInfo")) {
          return this.$message.error({
            message: "您还没有登录，请先登录",
            duration: 1000,
          });
        }
      }
      this.$router.push({ name: url, query: data });
      location.reload();
    },
    jumps(url, data = {}) {
      window.sessionStorage.setItem("search", data.search);
      this.value = data.search;
      console.log(this.value);
      lists({
        category_id: "",
        keywords: this.search,
        page: 1,
        type: this.pices,
      }).then((res) => {
        console.log("res", res.data);
        if (res.data.useSn) {
          this.$router.push({
            name: "info",
            query: { id: res.data.data[0].id, sn: this.search.trim() },
          });
          location.reload();
          return;
        }
        console.log("url", this.$route.path);
        if (url == "type") {
          if (this.$route.path == "/type") {
            // this.$emit("searchApi", this.search);
            this.$router.push({ name: url, query: data });
            console.log("ssssssss", data);
            location.reload();
            return;
          }
        }
        this.$router.push({ name: url, query: data });
        console.log("data", data);
      });
    },
    log_out() {
      window.localStorage.clear();
      this.$router.push("/login");
    },
    userInfoTop() {
      if (!localStorage.getItem("userInfo")) {
        this.flag1 = true;
        this.flag = false;
        return;
      }
      this.flag = true;
    },
    //公司介绍
    companyIntroduction() {
      this.$router.push({ name: "company" });
    },
    //招聘信息
    recruitment() {
      this.$router.push({ name: "recruitment" });
    },
    //最新资讯
    infomation() {
      this.$router.push({ name: "newinfo" });
    },
    //帮主中心
    helpCenter() {
      this.$router.push({ name: "help", query: { id: 5 } });
    },
    vipBtn() {
      this.$router.push({ path: "/mine" });
    },
    Mini() {
      console.log("ss");
    },
    //历史记录
    goodSearchs() {
      if (JSON.parse(localStorage.getItem("userInfo"))) {
        this.userId = JSON.parse(localStorage.getItem("userInfo")).user_id;
      } else {
        this.userId = "";
      }
      goodSearch({ uid: this.userId }).then((res) => {
        // console.log('历史记录',res);
        if (res.code !== 1) {
          return;
        }
        this.goodSearchsLists = res.data;
      });
    },
    qiehuan(index) {
      this.activeClass = index;
      window.localStorage.setItem("activeClass", this.activeClass);
      if (this.activeClass == 0) {
        this.pices = 0;
      } else {
        this.pices = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.erImg {
  width: 200px;
  height: 200px;

  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .el-dialog--center .el-dialog__body {
  display: flex;
  justify-content: center;
}
.step {
  width: 800px;
}
.top {
  background-color: #011a2c;
  height: 54px;
}
.main {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  .set {
    cursor: pointer;
    div {
      margin-left: 50px;
    }

    .set-true {
      width: 101px;
      height: 31px;
      background: #0097fe;
      border-radius: 18px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.search {
  height: 178px;

  .logo {
    width: 218px;
    height: 88px;
  }
  .search-con {
    .search-input {
      width: 572px;
      height: 50px;
      border-radius: 27px;
      border: 1px solid #0097fe;
      input {
        border: none;
        margin-left: 30px;
        background-color: #f5f5f5;
        width: 420px;
        height: 40px;
      }
      .search-input-btn {
        width: 99px;
        height: 50px;
        background: #0097fe;
        border-radius: 0px 27px 27px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .search-text {
      margin-top: 10px;
      cursor: pointer;
      display: flex;
      width: 500px;
      flex-wrap: wrap;
      div {
        margin-right: 10px;
        margin-bottom: 5px;
      }
    }
  }
  .car {
    width: 186px;
    height: 50px;
    border-radius: 27px;
    border: 1px solid #0097fe;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    cursor: pointer;
    .car-num {
      width: 23px;
      height: 23px;
      background: #ff6701;
      color: #fff;
      border-radius: 50%;
      text-align: center;
      line-height: 23px;
    }
  }
}
.nav {
  height: 54px;
  background: #0093f8;
  .all-box {
    position: relative;
    width: 209px;
    margin-right: 30px;
    cursor: pointer;
    .all {
      width: 100%;
      background: #ffffff;
      height: 54px;
      font-size: 18px;
      color: #0093f8;
    }
    .nav-select {
      position: absolute;
      z-index: 9999;
      width: 100%;
      color: #fff;
      opacity: 0.9;
      padding: 10px 0;
      background-color: #0093f8;
      .nav-item {
        padding: 0 20px 0 30px;
        height: 40px;
      }
    }
  }

  .nav-tabs {
    div {
      color: #fff;
      width: 130px;
      text-align: center;
      height: 54px;
      line-height: 54px;
      cursor: pointer;
    }
    .nav-true {
      background-color: #ff6701;
    }
  }
}
.iqehuan {
  display: flex;
  margin-left: 20px;
  cursor: pointer;
}
.current_way {
  background: #0097fe;
  color: #fff;
  font-size: 12px;
  padding: 6px;
}
.s {
  font-size: 12px;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue